import { Component, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { CoreSelectors, ModulesSelectors } from '@serviceos-ng/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'serviceos-web-footer-screen',
    templateUrl: './footer-screen.component.html',
    styleUrls: ['./footer-screen.component.scss'],
})
export class FooterScreenComponent implements OnInit {

    @Select(CoreSelectors.brandName)
    brandName$!: Observable<string>;

    @Select(CoreSelectors.logo)
    logo$!: Observable<string>;

    @Select(ModulesSelectors.getSetting('privacy_policy_url'))
    privacy_policy_url$;

    @Select(ModulesSelectors.getComponentFromModule('account', 'partners'))
    partnersComponent$!: Observable<any>;

    @Select(ModulesSelectors.getComponentFromModule('account', 'automated_by'))
    automatedByComponent$!: Observable<any>;

    @Select(ModulesSelectors.getSetting('terms_and_conditions_url'))
    terms_and_conditions_url$;

    @Select(ModulesSelectors.getSetting('cancellation_policy_url'))
    cancellation_policy_url$;

    @Select(ModulesSelectors.getSetting('cookie_policy_url'))
    cookie_policy_url$;

    @Select(ModulesSelectors.getModuleConfigText('application'))
    applicationModuleTexts$!: Observable<any>;

    @Select(ModulesSelectors.getModuleConfigText('customer'))
    moduleCustomerTexts$!: Observable<any>;

    @Select(CoreSelectors.automated_brand)
    automated_brand$!: Observable<{
        automated_by_logo_url: any;
        automated_by_site_url: any;
    } | null>;

    public currentYear = new Date().getFullYear();

    public partners = [
        {
            url: 'asasa.com',
            image_url: 'https://files.dxr.cloud/20240422NJRhLr1x19gEEgzgSMk9uOdxizNJThDaAqQkkMSSQ0Cc7iXQvK6C'
        },
        {
            url: 'asasa.com',
            image_url: 'https://files.dxr.cloud/20240422NJRhLr1x19gEEgzgSMk9uOdxizNJThDaAqQkkMSSQ0Cc7iXQvK6C'
        },
        {
            url: 'asasa.com',
            image_url: 'https://files.dxr.cloud/20240422NJRhLr1x19gEEgzgSMk9uOdxizNJThDaAqQkkMSSQ0Cc7iXQvK6C'
        },
        {
            url: 'asasa.com',
            image_url: 'https://files.dxr.cloud/20240422NJRhLr1x19gEEgzgSMk9uOdxizNJThDaAqQkkMSSQ0Cc7iXQvK6C'
        },
        {
            url: 'asasa.com',
            image_url: 'https://files.dxr.cloud/20240422NJRhLr1x19gEEgzgSMk9uOdxizNJThDaAqQkkMSSQ0Cc7iXQvK6C'
        },
        {
            url: 'asasa.com',
            image_url: 'https://files.dxr.cloud/20240422NJRhLr1x19gEEgzgSMk9uOdxizNJThDaAqQkkMSSQ0Cc7iXQvK6C'
        }
    ]
    
    constructor(
        private store: Store
    ) {}

    ngOnInit(): void {
    }
}
